<div class="container-fluid">
    <div class="row flex">
        <div class="col-md-2 page-header flex">
            <a [routerLink]="['../cyclists']">
                <span pTooltip="{{ 'bikeshop.cyclist.import.back_to_cyclists' | translate }}" tooltipPosition="left"
                      class="fa fa-chevron-left font-button"></span>
            </a>
            {{ 'bikeshop.cyclist.import_csv' | translate}}
        </div>
        <div class="col-md-8"></div>
        <div class="col-md-2 flex" style="font-size:24px">
            <div pTooltip="{{ 'bikeshop.cyclist.import.load_data_from_csv_file' | translate }}" tooltipPosition="left"
                 class="fa hubtiger-import pull-right"
                 style="margin-left:auto;" (click)="fileUpload.click()"></div>
            <a href="/assets/csv-templates/CustomersTemplate.csv" target="_blank" download="CustomersTemplate.csv">
                <div pTooltip="{{ 'bikeshop.cyclist.import.download_template_csv_file' | translate }}"
                     tooltipPosition="left"
                     class="fa hubtiger-export pull-right"></div>
            </a>
        </div>
    </div>
    <div class="content">
        <div class="row margin-top-8" *ngIf="importRecords && importRecords.length>0">
            <div class="col-md-9"></div>
            <div class="col-md-3">
                <button pButton type="button" class="p-button-raised full-width"
                        label="{{ 'bikeshop.cyclist.import.button.import_data_to_hubtiger' | translate }}"
                        [disabled]="uploading" (click)="importData()"></button>
            </div>
        </div>
        <div class="row margin-top-8" *ngIf="importRecords && importRecords.length>0">
            <div class="col-md-12" style="text-align: right;font-style: italic;">
                <div [innerHtml]="'bikeshop.cyclist.import.import_message' | translate:{'importRecords' : importRecords.length, 'noEmailCount': noEmailCount}"></div>
            </div>
        </div>
        <div class="row margin-top-8" *ngIf="importRecords && importRecords.length>0">
            <div class="col-md-12">
                <p-progressBar [value]="progressValue"></p-progressBar>
            </div>
        </div>
        <input #fileUpload type="file" accept=".csv" style="display: none;" (change)="importCyclists($event)">
        <div class="margin-top-16">
            <p-table #serviceTypesTable 
            [columns]="columns" 
            [value]="importRecords"
            [paginator]="true"
            [rows]="500">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" style="vertical-align: middle;"
                                        *ngIf="col.type !== 'action'">
                            </p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-serviceType let-columns="columns">
                    <tr [pSelectableRow]="serviceType">
                        <td *ngFor="let col of columns" [ngClass]="{'exists': serviceType['exists']}">
                            <div *ngIf="col.type!=='action'">
                                {{serviceType[col.field]}}
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
